"use client";
import { useState } from "react";
import { poppins } from "./ui/fonts";
import Image from "next/image"
import { inter } from "./ui/fonts"
import Link from "next/link";
import PasswordInput from "./ui/passwordInput";
import { useRouter } from "next/navigation";
import { useAuth } from "@/context/AuthContext";
import { AlertCircle } from "lucide-react";

export default function LoginForm() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const router = useRouter()
    const {login} = useAuth()


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsLoading(true);
        setError(null);

        const result = await login({ email, password });

        if (result.success) {
            router.push("/dashboard");
        } else {
            setError(result.error ?? "Login failed. Please try again.");
            setIsLoading(false);
        }
    }
    
    return (
        <div className="flex flex-col items-center justify-center  h-screen p-6">
            <div className="flex flex-col items-center justify-center bg-white border border-gray-200 p-10 rounded-lg shadow-sm box-border mt-[100px] w-fit sm:w-[500px]">
                <div className="w-10 h-10 bg-slate-100 rounded-[50%] flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-500 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeWidth="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                </div>
                <h1 className={`${poppins.className} mt-4 text-2xl font-semibold`}>Log in</h1>

                <form className="w-full" onSubmit={handleSubmit}>
                    <div className="flex flex-col justify-center w-full">
                        <label className={`${inter.className} text-[14px] font-medium`}>Email</label>
                        <input onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" className={`${inter.className} border border-gray-200 text-[14px] w-full px-3 py-[8px] focus:border-[#007F61] placeholder-slate-400 rounded-md mt-2  focus:outline-none focus:ring-[3px] focus:ring-[#6faa9b] focus:ring-opacity-50`} />
                        <label className={`${inter.className} text-[14px] font-medium mt-5`}>Password</label>
                        <PasswordInput onChange={(e) => setPassword(e.target.value)} value={password} />
                        {error && (
                            <div className={`${inter.className} flex items-start gap-2 mt-3 bg-red-50 border border-red-200 text-red-700 text-[13px] rounded-md px-3 py-2.5`}>
                                <AlertCircle className="w-4 h-4 mt-[1px] shrink-0" />
                                <span>{error}</span>
                            </div>
                        )}
                    </div>
                    <button disabled={isLoading} className={`${inter.className} flex items-center justify-center gap-2 bg-[#007F61] text-white font-medium text-[15px] py-2 rounded-md w-full mt-6 hover:bg-[#00674f] transition duration-300 ease-in-out shadow-sm antialiased disabled:opacity-70 disabled:cursor-not-allowed`}>
                        {isLoading && (
                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                            </svg>
                        )}
                        {isLoading ? "Logging in..." : "Log in"}
                    </button>
                </form>
            </div>
        </div>
    )
}